module.exports = __webpack_public_path__ + "static/media/pot-stickers.8eee42e2.jpg";